import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=b205d6ac&scoped=true&"
import script from "./AlertIcon.vue?vue&type=script&lang=js&"
export * from "./AlertIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b205d6ac",
  null
  
)

export default component.exports